import { Plugin } from '@nuxt/types';
import { initializeAxios } from '../util/axiosInitializer';

const accessor: Plugin = ({ $axios }) => {
  initializeAxios($axios);
};

export default accessor;
